import type { Transaction } from "./finance.ts";
export const permissionKeys = ["credit", "debit", "kpis", "charts", "pies", "comparison", "budget", "reports", "export"] as const;
export type PermissionKey = typeof permissionKeys[number];
export type FinancePermissions = Record<PermissionKey, boolean>;
export type FinanceAccessRole = "owner" | "user" | "customer_care" | "leader";
export const readRoles = ["user", "customer_care", "leader"] as const;
export type ReadRole = typeof readRoles[number];
export const permissionLabels: Record<PermissionKey, { id: string; en: string }> = {
  credit: { id: "Mutasi Kredit", en: "Credit transactions" }, debit: { id: "Mutasi Debet", en: "Debit transactions" },
  kpis: { id: "Ringkasan pemasukan, pengeluaran, dan laba", en: "Income, expense and profit summary" },
  charts: { id: "Grafik dan kinerja brand", en: "Charts and brand performance" }, pies: { id: "Pie diagram kategori", en: "Category pie charts" },
  comparison: { id: "Perbandingan periode", en: "Period comparison" }, budget: { id: "Budgeting", en: "Budgeting" },
  reports: { id: "Laporan laba/rugi", en: "Profit/loss reports" }, export: { id: "Ekspor data yang diizinkan", en: "Export allowed data" },
};
export function defaultPermissions(role: FinanceAccessRole): FinancePermissions {
  return Object.fromEntries(permissionKeys.map((key) => [key,
    role === "owner" || role === "user" || (role === "customer_care" ? key === "credit" : ["credit", "debit", "kpis", "charts", "pies", "comparison"].includes(key)),
  ])) as FinancePermissions;
}
export function parsePermissions(value: unknown): FinancePermissions {
  const object = value && typeof value === "object" ? value as Record<string, unknown> : {};
  return Object.fromEntries(permissionKeys.map((key) => [key, object[key] === true])) as FinancePermissions;
}
export function permittedTransaction(row: Pick<Transaction, "direction">, permissions: FinancePermissions) {
  return row.direction === "CREDIT" ? permissions.credit : row.direction === "DEBIT" ? permissions.debit : false;
}
export function accessRoleLabel(role: FinanceAccessRole) {
  return role === "owner" ? "Owner" : role === "customer_care" ? "Customer Care" : role === "leader" ? "Leader" : "User";
}
export type RolePolicy = { role: ReadRole; permissions: FinancePermissions; updatedAt: string };
